import { render, staticRenderFns } from "./TreeInfoCard.vue?vue&type=template&id=19289315&scoped=true&"
import script from "./TreeInfoCard.vue?vue&type=script&lang=ts&"
export * from "./TreeInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./TreeInfoCard.vue?vue&type=style&index=0&id=19289315&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19289315",
  null
  
)

export default component.exports